import React from 'react'
import { connect } from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import qs from 'qs';
import {
  getAdminEmpresa, getFiscalEmbarque,
  getGestorEmpresa,
  getMotoristaEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import buscarDetalhamentoFinanceiroEncomenda from '../../actions/itinerario/buscarDetalhamentoFinanceiroEncomenda';
import { formatarReal } from '../../util/numberUtil';
import { Link } from 'react-router-dom';

export class PainelDetalhamentoFinanceiroItinerarioEncomenda extends React.Component {
  constructor(props) {
    super(props);
    this.handleChecked = this.handleChecked.bind(this);

    this.state = {
      exibePainel: true,
    }
  }

  getParametros() {
    return qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
  }

  UNSAFE_componentWillMount() {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (parametros.itinerario) {
      this.setState({
        buscarDetalhamentoFinanceiroEncomenda: parametros.encomenda,
      }
      )
      this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
      this.props.buscarDetalhamentoFinanceiroEncomenda(parametros.itinerario, this.props.empresaSelecionada.id)
    } else {
      this.props.history.push('/painel-itinerarios');
    }
  }

  exibirBotoes() {
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-itinerarios">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>
          <a target="_BLANK" onClick={() => window.print()} style={{ cursor: 'pointer' }} className="btn  btn-sm btn-laranja ml-2">
            <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
        </div>
      </React.Fragment>)
  }

  handleChecked() {
    this.setState({ exibePainel: !this.state.exibePainel });
  }

  exibirPainelDetalhadoOuResumido() {
    return (
      <div className='row justify-content-md-center mt-2'>
        <div className='form-group form-check'>
          <input type="radio" name='exibePainel'
            className='form-check-input' onChange={this.handleChecked} value={this.state.exibePainel} checked={this.state.exibePainel} />
          <label className='form-check-label'>Detalhado</label>
        </div>
        <div className='form-group form-check ml-2'>
          <input type="radio" name='exibePainel'
            className='form-check-input' onChange={this.handleChecked} value={!this.state.exibePainel} checked={!this.state.exibePainel} />
          <label className='form-check-label'>Resumido</label>
        </div>
      </div>
    )
  }

  exibirEncomendas(detalhamento) {
    if (detalhamento.encomendas && detalhamento.encomendas.length) {
      return <table className="table table-responsive table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
        {this.exibirCabecalhoTabela(detalhamento)}
        <tbody>
          {detalhamento.encomendas.map(encomenda =>
            <tr key={`reserva-${encomenda.id}`}>
              <td>
                <span>{encomenda.id}</span>
              </td>
              <td>
                <span>{encomenda.dataCriacao}</span>
              </td>
              <td>
                <span>{encomenda.remetente.nome}</span>
              </td>
              <td>
                <span>{encomenda.destinatario.nome}</span>
              </td>
              <td>{`${encomenda.cidadeOrigem} -> ${encomenda.cidadeDestino}`}</td>
              <td>
                <span>{formatarReal(encomenda.valorEncomenda)}</span>
              </td>
              <td>
                <span>{formatarReal(encomenda.comissao)}</span>
              </td>
              <td>
                <span>{formatarReal(encomenda.impostoRetido)}</span>
              </td>
              <td>
                <span>{formatarReal(encomenda.valorLiquidoEmpresa)}</span>
              </td>
            </tr>)}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="5"><strong>TOTAIS</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotal)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalComissao)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorTotalImpostoRetido)}</strong></td>
            <td><strong>{formatarReal(detalhamento.valorAcerto)}</strong></td>
          </tr>
        </tfoot>
      </table>
    }
  }

  exibirCabecalhoTabela(detalhamento) {
    return <thead>
      <tr>
        <td colSpan={12}>
          <strong>{detalhamento.agencia ? detalhamento.agencia + ': ' : ''}{detalhamento.vendedor}</strong>
        </td>
      </tr>
      <tr>
        <th scope='col'>Nº Encomenda</th>
        <th scope="col">Data da Venda</th>
        <th scope="col">Remetente</th>
        <th scope="col">Destinatário</th>
        <th scope="col">Trecho</th>
        <th scope="col">Valor Encomenda</th>
        <th scope="col">Comissão</th>
        <th scope="col">Imposto Retido</th>
        <th scope="col">Liq. Empresa</th>
      </tr>
    </thead>
  }

  exibir() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return <React.Fragment>
        {this.props.detalhamentoFinanceiroEncomenda.map((detalhamento, index) => <div key={index}>
          {this.exibirEncomendas(detalhamento)}
        </div>)
        }
      </React.Fragment>
    }
    return <div className="alert alert-warning text-center" role="alert">
      Itinerário não possui encomendas vendidas
    </div>
  }

  calcularTotalValor() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return this.props.detalhamentoFinanceiroEncomenda.map(v => Number(v.valorTotal))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalComissao() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return this.props.detalhamentoFinanceiroEncomenda.map(v => Number(v.valorTotalComissao))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalImpostoRetido() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return this.props.detalhamentoFinanceiroEncomenda.map(v => Number(v.valorTotalImpostoRetido))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  calcularTotalValorLiquido() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return this.props.detalhamentoFinanceiroEncomenda.map(v => Number(v.valorAcerto))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  recuperarTotalEncomendas() {
    if (this.props.detalhamentoFinanceiroEncomenda && this.props.detalhamentoFinanceiroEncomenda.length) {
      return this.props.detalhamentoFinanceiroEncomenda.map(v => Number(v.encomendas.length))
        .reduce((sum, current) => sum + current);
    }
    return 0;
  }

  exibePainelDetalhado() {
    return (
      <>
        {this.exibir()}
      </>
    )
  }

  exibePainelResumido() {
    return (
      <div className='mt-2'>
        <table className="table table-responsive-sm table-sm table-bordered text-center page-break" style={{ backgroundColor: '#FFF' }}>
          <thead>
            <tr>
              <td><strong>Descrição</strong></td>
              <td><strong>Valor da Encomenda</strong></td>
              <td><strong>Comissão Vendedor</strong></td>
              <td><strong>Imposto Retido</strong></td>
              <td><strong>Liq. Empresa</strong></td>
            </tr>
          </thead>
          <tbody>
            {this.props.detalhamentoFinanceiroEncomenda.map((detalhamento, indice) => (
              detalhamento.encomendas && detalhamento.encomendas.length &&
              <tr key={`detalhamento-reservas-${indice}`}>
                <td>{detalhamento.agencia ? detalhamento.agencia + ': ' : ''}{detalhamento.vendedor}</td>
                <td>{formatarReal(detalhamento.valorTotal)}</td>
                <td>{formatarReal(detalhamento.valorTotalComissao)}</td>
                <td>{formatarReal(detalhamento.valorTotalImpostoRetido)}</td>
                <td>{formatarReal(detalhamento.valorAcerto)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th>TOTAIS</th>
              <th>{formatarReal(this.calcularTotalValor().toString())}</th>
              <th>{formatarReal(this.calcularTotalComissao().toString())}</th>
              <th>{formatarReal(this.calcularTotalImpostoRetido().toString())}</th>
              <th>{formatarReal(this.calcularTotalValorLiquido().toString())}</th>
            </tr>
          </tfoot>
        </table>
      </div>)
  }

  render() {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getMotoristaEmpresa(this.props.empresaSelecionada.id),
        getFiscalEmbarque(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id)]}
        empresaSelecionada={this.props.empresaSelecionada}>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div className='text-center mb-4 mt-4'>
            {this.state.exibePainel ? <h2>Detalhamento Financeiro Encomendas</h2> : <h2>Resumo Finaceiro das Encomendas</h2>}
            {this.exibirPainelDetalhadoOuResumido()}
          </div>
          <div className="col-12">
            <strong>{this.props.empresaSelecionada.nome}</strong>
            <br />
            <strong>Rota:</strong> {this.props.itinerarioSelecionado.rotaDto.prefixo ? this.props.itinerarioSelecionado.rotaDto.prefixo + ' - ' : ''}{this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nomeComUf} -&gt; {this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nomeComUf}
            <br />
            <br />
            <strong>Prestador:</strong> {this.props.itinerarioSelecionado.prestador ? this.props.itinerarioSelecionado.prestador.valor : '-'}
            <br />
            <strong>Data: </strong>{this.props.itinerarioSelecionado.dataHoraPartida}
            <br />
            <strong>Veículo:</strong> {this.props.itinerarioSelecionado.veiculoDto.descricao}
            <br />
            <strong>Total de encomendas:</strong> {this.recuperarTotalEncomendas()}
            <br />
            <strong>Total vendido:</strong> {formatarReal(this.calcularTotalValor().toString())}
            <br />
            <strong>Total imposto retido:</strong> {formatarReal(this.calcularTotalImpostoRetido().toString())}
            <br />
            <strong>Total comissão:</strong> {formatarReal(this.calcularTotalComissao().toString())}
            <br />
            <strong>Total líquido:</strong> {formatarReal((this.calcularTotalValorLiquido()).toString())}
            <br />
            <strong>Quilometragem: </strong>{this.props.itinerarioSelecionado.quilometragem}
          </div>

          <div className='mt-2'>
            {this.state.exibePainel ?
              this.exibePainelDetalhado()
              : this.exibePainelResumido()}
          </div>

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
          </Autorizacao>
        </div>
      </Autorizacao>
    );
  }
}

export function mapStateToProps(state) {
  return {
    itinerarioSelecionado: state.itinerarioSelecionado,
    empresaSelecionada: state.empresaSelecionada,
    detalhamentoFinanceiroEncomenda: state.detalhamentoFinanceiroEncomenda,
    idUsuario: state.authentication.idUsuario,
  }
}

export default connect(mapStateToProps, {
  buscarDetalhamentoFinanceiroEncomenda,
  buscarItinerario,
})(PainelDetalhamentoFinanceiroItinerarioEncomenda);
